<template>
  <div class="page_win changePwdBox">
    <div class="topContent">
      <div class="topContent_l" @click="back">
        <img :src="returnRightImg" alt="" />
      </div>
      <div class="topContent_m">
        <span>修改密码</span>
      </div>
      <div class="closeBtn" @click="close">
        <img :src="closeImg" alt="" />
      </div>
    </div>
    <div class="bottomContent">
      <div class="view_group">
        <div class="view_group_l">
          <img :src="accountImg" class="account_icon" alt="" />
          <input
            placeholder-style="color:#999"
            type="text"
            name="uname"
            v-model="uname"
            placeholder="请输入用户名"
          />
        </div>
        <!-- <div class="view_group_r" @click="uname = ''">
          <img :src="close_icon2" alt="" />
        </div> -->
      </div>

      <div class="view_group">
        <div class="view_group_l">
          <img :src="passImg" class="pwd_icon" alt="" />
          <input
            placeholder-style="color:#999"
            style="width: 100%"
            maxlength="10"
            type="password"
            name="pwd"
            v-model="pwd"
            placeholder="请输入旧密码"
          />
        </div>
        <!-- <div class="view_group_r" @click="pwd = ''">
          <img :src="close_icon2" alt="" />
        </div> -->
      </div>
      <div class="view_group">
        <div class="view_group_l">
          <img :src="passImg" class="pwd_icon" alt="" />
          <input
            style="width: 100%"
            placeholder-style="color:#999"
            maxlength="10"
            type="password"
            name="newPassEidt"
            v-model="newPassEidt"
            placeholder="请输入新密码"
          />
        </div>
        <!-- <div class="view_group_r" @click="newPassEidt = ''">
          <img :src="close_icon2" alt="" />
        </div> -->
      </div>
    </div>
    <div class="bot_btn" @click="editPassConfirm">确认修改</div>
  </div>
</template>

<script>
import { hex_md5 } from "@/common/js/md5";
import fun from "@/common/js/common";
import Clipboard from "clipboard";
export default {
  name: "alertPwd",
  inject: ["reload"],
  data() {
    return {
      outIcon: require("../../assets/img/out.png"),
      myName: "",
      old_pwd: "",
      new_pwd: "",
      userInfo: "",
      uname: "",
      pwd: "",
      newPassEidt: "",
      returnRightImg: require("../../assets/img/new2/back.png"),
      closeImg: require("../../assets/img/new2/close.png"), // 关闭
      close_icon2: require("../../assets/img/view6/close2.png"), // 关闭
      passImg: require("../../assets/img/view6/pwd.png"),
      accountImg: require("../../assets/img/view6/account.png"),
    };
  },
  created() {},
  mounted() {
    this.userInfo =
      localStorage.getItem("userInfo") &&
      localStorage.getItem("userInfo") != "undefined"
        ? JSON.parse(localStorage.getItem("userInfo"))
        : {};
  },
  methods: {
    back() {
      this.$store.dispatch("IsAlertPwdFun", false);
      this.$store.dispatch("IsUserInfoMaskFun", true);
    },
    close() {
      this.$store.dispatch("IsAlertPwdFun", false);
    },

    // 确认修改密码
    editPassConfirm() {
      if (!this.uname) {
        this.$toast.test("请输入用户名");
        return false;
      }
      if (!this.pwd) {
        this.$toast.test("请输入旧密码");
        return false;
      }
      if (!this.newPassEidt) {
        this.$toast.test("请输入新密码");
        return false;
      }
      var time = new Date().getTime();
      let data = {
        adid: this.adid,
        time: time,
        uname: this.uname,
        pwd: this.pwd,
        newpwd: this.newPassEidt,
        os: localStorage.getItem("os"),
      };
      this.$http.post(fun.apiUrl + "api/member/password", data).then(
        function (res) {
          if (res.body.code === 200) {
            localStorage.removeItem("userInfo");
            this.$toast.text(res.body.msg);
            this.$store.dispatch("IsAlertPwdFun", false);
            this.reload();
          } else {
            this.$toast.test(res.body.msg);
          }
        },
        function (res) {}
      );
    },
  },
};
</script>

<style  lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
input:-webkit-autofill {
  transition: background-color 5000s ease-in-out 0s;
}
::-webkit-input-placeholder {
  color: #bcbcbc;
}
::-moz-placeholder {
  color: #bcbcbc;
} /* firefox 19+ */
:-ms-input-placeholder {
  color: #bcbcbc;
} /* ie */
input:-moz-placeholder {
  color: #bcbcbc;
}
.topContent {
  height: 0.68rem;
  @include flex_box(row, space-between, stretch);
  position: relative;
}
.topContent_l,
.topContent_m,
.closeBtn {
  @include flex_box(row, center, center);
}
.topContent_l,
.closeBtn {
  position: absolute;
  top: 0;
  width: 0.8rem;
  height: 0.68rem;
  img {
    height: 0.32rem;
    width: auto;
  }
}
.topContent_m {
  flex: 1;
  span {
    font-size: 0.38rem;
    font-weight: 600;
    letter-spacing: 2px;
    color: #FF913A;
    line-height: 0.68rem;
  }
}
.topContent_l {
  left: 0;
  justify-content: flex-start;
}
.closeBtn {
  right: 0;
  justify-content: flex-end;
}
.bottomContent {
  @include flex_box(column, none, stretch);
}
.view_group {
  position: relative;
  padding: 0 0.22rem;
  border-radius: 0.1rem;
  margin-top: 0.34rem;
  height: 0.82rem;
  @include flex_box(row, space-between, center);
  border: 1px solid #FF913A;
}


</style>



// WEBPACK FOOTER //
// src/views/view8/alertPwd.vue